function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "text-icon-v2-a",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "text-icon-v2-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#text-icon-v2-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#E3E7F4",
  fillRule: "nonzero",
  xlinkHref: "#text-icon-v2-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9097B2",
  fillRule: "nonzero",
  d: "M4,19 L26,19 L26,20 L4,20 L4,19 Z M4,15 L26,15 L26,16 L4,16 L4,15 Z M4,23 L26,23 L26,24 L4,24 L4,23 Z M4,27 L26,27 L26,28 L4,28 L4,27 Z M4,31 L26,31 L26,32 L4,32 L4,31 Z",
  mask: "url(#text-icon-v2-b)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 20,
  fill: "#CFD4E5",
  fillRule: "nonzero",
  mask: "url(#text-icon-v2-b)"
}));

var SvgText = function SvgText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/text.340e503f.svg";
export { ForwardRef as ReactComponent };